import { defineComponent, toRefs, ref, watch, nextTick, computed, openBlock, createElementBlock, normalizeClass, normalizeStyle } from "vue";
import { getPrefixCls } from "../_utils/global-config.js";
import _export_sfc from "../_virtual/plugin-vue_export-helper";
const _sfc_main = defineComponent({
  name: "TabsNavInk",
  props: {
    activeTabRef: {
      type: Object,
      required: true
    },
    direction: {
      type: String,
      required: true
    },
    disabled: Boolean,
    animation: Boolean
  },
  setup(props) {
    const { activeTabRef, direction } = toRefs(props);
    const prefixCls = getPrefixCls("tabs-nav-ink");
    const style = ref({});
    watch([activeTabRef, direction], ([tabRef, direction2]) => {
      nextTick(() => {
        if (direction2 === "vertical") {
          style.value = {
            top: `${tabRef.offsetTop}px`,
            height: `${tabRef.offsetHeight}px`
          };
        } else {
          style.value = {
            left: `${tabRef.offsetLeft}px`,
            width: `${tabRef.offsetWidth}px`
          };
        }
      });
    }, { immediate: true });
    const cls = computed(() => [
      prefixCls,
      {
        [`${prefixCls}-animation`]: props.animation,
        [`${prefixCls}-disabled`]: props.disabled
      }
    ]);
    return {
      prefixCls,
      cls,
      style
    };
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.cls),
    style: normalizeStyle(_ctx.style)
  }, null, 6);
}
var TabsNavInk = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export { TabsNavInk as default };
